/**
 * Custom permission definitions for Backstage
 *
 * These permissions can be used in the frontend with RequirePermission
 * or with usePermission hook for conditional programming
 * and will be checked by the AwsSsoPermissionPolicy in the backend.
 *
 * Note: Custom permissions must have a resourceType of CUSTOM_PERMISSION_RESOURCE_TYPE
 * to be handled by the AwsSsoPermissionPolicy in the backend.
 * If not provided, the permission will be allowed by default.
 *
 * Example:
 * export const toggleEnvironmentPermission = createPermission({
 *   name: 'environment.status.update',
 *   attributes: { action: 'update' },
 *   resourceType: CUSTOM_PERMISSION_RESOURCE_TYPE,
 * });
 */

import { createPermission } from '@backstage/plugin-permission-common';

export const CUSTOM_PERMISSION_RESOURCE_TYPE = 'custom-permission';

export const toggleEnvironmentPermission = createPermission({
  name: 'custom.environment.toggle',
  attributes: { action: 'update' },
  resourceType: CUSTOM_PERMISSION_RESOURCE_TYPE,
});
